module.exports = __webpack_public_path__ + "media/T-360_Responder.c4f7e3c5.mp4";